import React from 'react'
import { LuEye } from 'react-icons/lu'
import { SessionManager } from '../../utils'

export default function ActionDetails(props) {

    const { text, route_name, onClick } = props

    var permission = JSON.parse(SessionManager.getSession('permission'))
 
    return (
        <>
            {permission?.some(val => val.sub_action_name == route_name) &&
                <LuEye size={16} className='action-button text-info me-3'
                    onClick={onClick}
                    data-tooltip-id="global-table-tooltip"
                    data-tooltip-content={text}
                    data-tooltip-place="bottom"
                    data-tooltip-class-name="bg-info tooltip_msg"
                />
            }
        </>
    )
}
